import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2777ff14&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=2777ff14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2777ff14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2777ff14')) {
      api.createRecord('2777ff14', component.options)
    } else {
      api.reload('2777ff14', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=2777ff14&scoped=true&", function () {
      api.rerender('2777ff14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/configuration/forms/Index.vue"
export default component.exports